import React, { useEffect } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Alert, Col, Row } from 'react-bootstrap';

import './Retenciones.css';

import useStore from '../../store';
import RetencionList from './list/RetencionList';
import RetencionSearch from './list/components/RetencionSearch';
import RetencionesItemActions from './list/components/RetencionesItemActions';
import RetencionesToolbarActions from './list/components/RetencionesToolbarActions';

const mapState = (state) => {
  return state.app.retenciones.list;
}

const mapActions = (actions) => {
  return actions.app.retenciones.list;
}

const Retenciones = (props) => {
  const [state, actions] = useStore(mapState, mapActions);

  useEffect(() => {
    window.setAppTitle('Retenciones');

    return () => actions.clearSelection();
  }, []); // eslint-disable-line

  const handleOnRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    actions.setSelection(selectedRows, selectedRowKeys);
  }

  const handleOnRowClick = (data) => {
    props.history.push({
      pathname: `/app/retenciones/${data.uuid}/info`,
      state: {
        data: {
          ...data
        }
      }
    });
  }

  const handleOnToggleSelectableItems = () => {
    const { selectable } = state;

    actions.setSelectable(!selectable)
  }

  const hideError = () => {
    actions.resetError();
  }

  const { error, selectedRowKeys, selectedRows } = state;

  return (
    <div className="retenciones">
      { !error && (
        <Row>
          <Col sm="auto" md="9" className="mb-2">
            <div>
              { selectedRowKeys.length > 0 && (
                <div className="mr-3 d-inline-flex pb-2">
                  <RetencionesItemActions selectedRows={ selectedRows } />
                </div>
              )}

              { selectedRowKeys.length === 0 && (
                <RetencionSearch />
              )}
            </div>
          </Col>

          <Col md="3" className="text-right mb-2">
            <RetencionesToolbarActions
              onToggleSelectableItems={ handleOnToggleSelectableItems }
            />
          </Col>

        </Row>
      )}

      { !!error && (
        <Row>
          <Col>
            <Alert variant="danger"
              onClose={ hideError }
              dismissible
            >
              <Alert.Heading>Oh no!</Alert.Heading>
              { error.message }
            </Alert>
          </Col>
        </Row>
      )}

      { Guardian.allows('retencion.listar') &&
        <RetencionList
          onRowClick={ handleOnRowClick }
          onRowSelectionChange={ handleOnRowSelectionChange }
        />
      }
    </div>
  )
}

export default Retenciones;